import { IdType, SharingData } from './schema/SharingData';
import { SharingInfoBase } from './schema/SharingInfoBase';
import { ODBSharingInfo } from './schema/ODBSharingInfo';
import { ODCSharingInfo } from './schema/ODCSharingInfo';
import { SharingRecipientsInfo } from './schema/SharingRecipientsInfo';
import { getSharingTipIdsList, SharingTipId } from './types/sharingTipId';
import { SharingTipInfo } from './types/SharingTipInfo';
import { SharingTipRecipientInfo } from './types/SharingTipRecipientInfo';
import { SharingTipAction } from './types/SharingTipAction';
import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "SharingData", webpackPrefetch: true */ './lazyIndex')
);

// Delay loaded services
export const lazyGetSharingInformation = new LazyImport(lazyModule, m => m.getSharingInformation);

// delay loaded utils
export const lazyGetSharingIssuesForSharingData = new LazyImport(
    lazyModule,
    m => m.getSharingIssuesForSharingData
);
export const lazyGetInfoBarCreator = new LazyImport(lazyModule, m => m.getInfoBarCreator);
export const lazyHasLargeDLRecipient = new LazyImport(lazyModule, m => m.hasLargeDLRecipient);
export const lazyhasRecipientExpansionFailure = new LazyImport(
    lazyModule,
    m => m.hasRecipientExpansionFailure
);
export const lazyGetGroupsAndSmallDLs = new LazyImport(lazyModule, m => m.getGroupsAndSmallDLs);
export const lazyGetInvididualRecipients = new LazyImport(
    lazyModule,
    m => m.getInvididualRecipients
);
export const lazyHasGetRecipientPermissionFailed = new LazyImport(
    lazyModule,
    m => m.hasGetRecipientPermissionFailed
);
export const lazyLogSharingTipChangesForLinkRemoval = new LazyImport(
    lazyModule,
    m => m.logSharingTipChangesForLinkRemoval
);

// export public actions
export { refreshExpirationDate } from './actions/publicActions';

// Interfaces & constants
export {
    IdType,
    SharingTipId,
    SharingData,
    SharingInfoBase,
    ODBSharingInfo,
    ODCSharingInfo,
    SharingTipAction,
    SharingRecipientsInfo,
    SharingTipInfo,
    SharingTipRecipientInfo,
    getSharingTipIdsList,
};
export { INDIVIDUAL_RECIPIENT_MEMBER_COUNT, LARGE_DL_MEMBER_COUNT } from './utils/constants';
export { RecipientPermissionInfo, GetPermissionInfoStatus } from './schema/RecipientPermissionInfo';
